import { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import ListSelect from "src/components/ListSelect";
import ListButton from "src/components/ListButton";
import { ReactComponent as MusicIcon } from "src/modules/lullaby/icons/music-outlined.svg";
import getLullabyIcon from "src/modules/lullaby/icons/getLullabyIcon";
import SvgContainer from "src/components/SvgContainer";

function getNameForLullaby(lullaby) {
  let { name, libraryIdentifier } = lullaby;
  if (libraryIdentifier) {
    name = i18n.t(`lullaby.name.${libraryIdentifier}`);
  }
  return name;
}

export default function LullabySelect({
  onSelect,
  defaultLullaby,
  otherLullabies,
  disabled
}) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const items = useMemo(
    () =>
      otherLullabies.map((lullaby) => ({
        id: lullaby.objectId,
        name: getNameForLullaby(lullaby),
        contentBeforeName: (
          <SvgContainer
            fill="primary"
            size="20px"
            icon={getLullabyIcon(lullaby.libraryIdentifier)}
          />
        )
      })),
    [otherLullabies]
  );
  const defaultLullabyName = getNameForLullaby(defaultLullaby);
  const defaultLullabyIcon = (
    <SvgContainer
      fill="primary"
      size="20px"
      icon={getLullabyIcon(defaultLullaby.libraryIdentifier)}
    />
  );
  return (
    <>
      <ListButton
        iconFill="primary"
        disabled={disabled}
        label={t("lullaby")}
        onClick={() => setIsOpen(true)}
        additionalText={defaultLullabyName}
        icon={MusicIcon}
      />
      <ListSelect
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        heading={t("lullaby.select.heading")}
        items={items}
        selectedItem={{
          id: defaultLullaby.objectId,
          name: defaultLullabyName,
          contentBeforeName: defaultLullabyIcon
        }}
        onSelect={(id) => {
          onSelect(id);
          setIsOpen(false);
        }}
      />
    </>
  );
}
